// @vuese
// Mixin renderujący formularze
export const formRenderMixin = {
  props: {
    // Schema
    schema: {
      type: Object,
      required: true
    },
    // Nazwa wzoru formularza
    templateName: {
      type: String,
      required: true
    }
  },
  render(createElement) {
    return createElement(this.templateName, {
      props: { ...this.$attrs, ...this.$props },
      on: { update: () => this.$emit('update') }
    });
  }
};
